import { render } from "./RegMobileHero.vue?vue&type=template&id=496cc1f6&scoped=true"
import script from "./RegMobileHero.vue?vue&type=script&lang=js"
export * from "./RegMobileHero.vue?vue&type=script&lang=js"

import "./RegMobileHero.vue?vue&type=style&index=0&id=496cc1f6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-496cc1f6"]])

export default __exports__